<template>
  <div class="page-box">
    <div class="login-box">
      <img src="@/assets/images/logo4.png"/>
      <div class="input-li">
        <div class="input-title">手机号/账号</div>
        <div class="input-box">
          <el-input  v-model="phone" placeholder="请输入手机号/账号"></el-input>
        </div>
      </div>
      <div class="input-li">
        <div class="input-title">密码</div>
        <div class="input-box">
          <el-input  v-model="password" placeholder="请输入密码" type="password"></el-input>
        </div>
      </div>
      <!-- <div class="input-li">
        <div class="input-title">验证码</div>
        <div class="input-box">
          <el-input v-model="code" placeholder="请输入验证码"></el-input>
          <div class="verification" @click="getCode">
            <img :src="codeImg" alt="">
          </div>
        </div>
      </div> -->
      <div><el-button class="margin-top" type="primary" :disabled="isDisabled()" @click="onClickLogin">登录</el-button></div>
      <div class="code-login-text" @click="onClickRoute">手机验证码登录</div>
    </div>
  </div>
</template>

<script>
import { login, getCode, getCheckCode } from '@/api/login'
import { getCurrentUser } from '@/api/user'
import { setJSEncrypt } from '@/util/index.js'

export default {
  name: "login",
  data() {
    return {
      phone: '',
      password: '',
      code: '',
      codeImg: '',
      uuid: '',
    }
  },
  methods: {
    // 获取图片验证码
    getCode() {
      getCode().then(res => {
        this.codeImg = res.data[0].base64Image
        this.uuid = res.data[0].uuid
      })
    },
    onClickRoute() {
      this.$router.replace({ path: `/codeLogin` })
    },
    // 点击登录
    onClickLogin() {
      // this.getCheckCode()
      this.login()
    },
    // 校验图片验证码
    getCheckCode() {
      getCheckCode({
        uuid: this.uuid,
        code: this.code,
      }).then(res => {
        if(res.code == 'A00000') {
          this.login()
        }else {
          this.$message.error(res.message);
        }
      })
    },
    // 账号密码登录，返回token
    login() {
      login({
        username: this.phone,
        password: setJSEncrypt(this.password),
        client: 'OM_PC',
      }).then(async res => {
        if(res.code == 'A00000') {
          localStorage.setItem("x-token", res.extras['x-token'])
          await this.getCurrentUser()
          this.$router.push({ path: `/` })
        }else {
          this.$message.error(res.message);
          this.getCode()
        }
      })
    },
    // 获取当前登录用户
    async getCurrentUser() {
      await getCurrentUser().then(res => {
        if(res.code == 'A00000') {
          localStorage.setItem("userInfo", JSON.stringify(res.data[0]))
        }
      })
    },
    isDisabled() {
      if(this.phone == "" || this.password == "") {
        return true
      }
      return false
    }
  },
  mounted() {
    this.getCode()
  }
}
</script>

<style scoped lang="less">
  .margin-top {
    margin-top: 20px;
  }
  .page-box{
    background: url("~@/assets/images/logo-bg.jpg") no-repeat;
    background-size: 100% 100%;
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-login-text {
    margin-top: 10px;
    font-size: 16px;
    color: #BD181E;
    cursor: pointer;
  }
  .login-box>img{
    margin-bottom: 40px;
    width: 340px;
  }
  .login-box{
    background: #fff;
    box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    width: 640px;
    height: 710px;
    padding: 42px 92px 0 92px;
    box-sizing: border-box;
    /deep/.el-button{
      width: 100%;
      border: none;
      background: rgba(156, 29, 34, 1);
      height: 54px;
      font-size: 16px;
      margin-top: 20px;
    }
  }
  .input-box{
    position: relative;
  }
  .input-li{
    text-align: left;
    margin-bottom: 20px;
    .verification{
      position: absolute;
      width: 100px;
      height: 40px;
      background: #eee;
      right: 5px;
      top: 7px;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        vertical-align: bottom;
      }
    }
    /deep/.el-input__inner{
      border: 1px solid rgba(220, 223, 230, 1);
      height: 54px;
      font-size: 14px;
    }
    .input-title{
      font-size: 20px;
      margin-bottom: 12px;
      font-weight: bold;
      line-height: 28px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Login/index.vue